import {
  MEGA_WATT_CONVERSION_FACTOR,
  MIN_TO_HR_CONVERSION_FACTOR,
} from "@/constants/common.constants";
import type { AvailableEnergyTransformResponse } from "@/pages/Energy";
import { truncToFixed } from "./number.helpers";

export const getIdByName = (
  name: string,
  data: { name: string; id: string }[]
): string => {
  const asset = data.find((item) => item.name === name);
  return asset ? asset.id : "";
};

export const getEnergyFromPower = (
  power: number,
  from: number,
  to: number
): number => {
  const scheduleLength = (to - from) / MIN_TO_HR_CONVERSION_FACTOR; //in hours

  return power * scheduleLength;
};

export const getPowerFromEnergy = (
  energy: number,
  from: number,
  to: number
): number => {
  const scheduleLength = (to - from) / MIN_TO_HR_CONVERSION_FACTOR; //in hours

  return energy / scheduleLength;
};

export const convertWattHourToMegaWattHour = (wattHourValue: number) =>
  truncToFixed(wattHourValue / MEGA_WATT_CONVERSION_FACTOR, 1);

export const getAvailablePowerLimits = (
  availableEnergyArray: AvailableEnergyTransformResponse[],
  settlementPeriodDuration: number
) => {
  if (availableEnergyArray.length === 0) {
    return { maxAdditionalEnergy: undefined, minAdditionalEnergy: undefined };
  }

  let maxLimit = Infinity;
  let minLimit = -Infinity;
  availableEnergyArray.forEach(
    ({ maxAdditionalEnergy, minAdditionalEnergy }) => {
      if (maxAdditionalEnergy !== undefined && maxAdditionalEnergy < maxLimit) {
        maxLimit = maxAdditionalEnergy;
      }
      if (minAdditionalEnergy !== undefined && minAdditionalEnergy > minLimit) {
        minLimit = minAdditionalEnergy;
      }
    }
  );

  //returning average power over 1 sp
  return {
    maxAdditionalEnergy: maxLimit * (60 / settlementPeriodDuration),
    minAdditionalEnergy: minLimit * (60 / settlementPeriodDuration),
  };
};
